/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable no-param-reassign */
import { PayloadAction, createSlice } from '@reduxjs/toolkit';

// todo: proper types and status

export type DigioDocumentCallback = {
  txn_id: string;
  digio_doc_id: string;
  message: string;
  error_code: string;
};

export type ESignDataResponse = {
  eSignRequestID: string;
  identifier: string;
  token: string;
  name: string;
  signed: boolean;
}
export interface DigioFormState {
  status: 'idle' | 'loading' | 'success' | 'error';
  isImageVerificationStarted: boolean;
  imageVerificationCredentials: {
    identifier: string,
    requestId: string,
    token: string
  } | null;
  isImageVerified: boolean;
  isKycVerificationStarted: boolean;
  kycCredentials: {
    identifier: string,
    requestId: string,
    token: string
  } | null;
  isKycVerified: boolean;

  isEsignVerificationStarted: boolean;
  esignCredentials: {
    identifier: string,
    requestId: string
    token: string
  } | null;
  isEsignVerified: boolean;
  eSignData: ESignDataResponse[] | null;
  isUserDeclarationSaved: boolean;
  isUserSignSaved: boolean;
  error: {
    isError: boolean,
    type: string | null,
    message: string | null
  }
}

const initialState: DigioFormState = {
  status: 'idle',
  isImageVerificationStarted: false,
  isImageVerified: false,
  imageVerificationCredentials: null,
  isKycVerificationStarted: false,
  isKycVerified: false,
  kycCredentials: null,
  isEsignVerificationStarted: false,
  isEsignVerified: false,
  // esignCredentials: null,
  esignCredentials: null,
  eSignData: null,
  isUserDeclarationSaved: false,
  isUserSignSaved: false,
  error: {
    isError: false,
    type: null,
    message: '',
  },
};

export const digioSlice = createSlice({
  name: 'digio',
  initialState,
  reducers: {
    getDigioImageVerifyCredentials: (state) => { },
    setDigioImageVerifyCredentials: (state, action) => {
      state.imageVerificationCredentials = action.payload;
      state.isImageVerificationStarted = true;
      state.status = 'success';
    },
    verifyDigioImageVerification: (state, action) => { },
    setDigioImageVerificationStatus: (state, action) => {
      state.status = 'success';
      state.isImageVerified = action.payload;
    },
    getDigioKycCredentials: (state) => { },
    setDigioKycCredentials: (state, action) => {
      state.kycCredentials = action.payload;
      state.isKycVerificationStarted = true;
      state.status = 'success';
    },
    verifyDigioKyc: (state, action) => { },
    setDigioKycVerificationStatus: (state, action) => {
      state.status = 'success';
      state.isKycVerified = action.payload;
    },
    getAadhaarEsignCredentials: (state) => { },
    setAadhaarEsignCredentials: (state, action: PayloadAction<ESignDataResponse[]>) => {
      state.eSignData = action.payload
      state.isEsignVerificationStarted = true;
      state.status = 'success';
    },
    verifyAadhaarEsign: (state, action) => { },
    setAadhaarEsignVerificationStatus: (state, action) => {
      state.status = 'success';
      state.isEsignVerified = action.payload;
    },
    saveUserDeclaration: (state, action) => { },
    setUserDeclarationStatus: (state, action) => {
      state.isUserDeclarationSaved = action.payload;
      state.status = 'success';
    },
    saveUserSign: (state, action) => { },
    setUserSignStatus: (state, action) => {
      state.isUserSignSaved = action.payload;
      state.status = 'success';
    },
    setDigioFormError: (state, action) => {
      state.error = action.payload;
      state.status = 'error';
    },
    setDigioFormStatus: (state, action) => {
      state.status = action.payload;
    },
    clearDigioFormError: (state) => {
      state.error = {
        isError: false,
        type: null,
        message: '',
      };
      state.status = 'idle';
    },
  },
});

// Actions
export const {
  getDigioImageVerifyCredentials, setDigioImageVerifyCredentials, setDigioFormError, setDigioFormStatus,
  clearDigioFormError, getDigioKycCredentials, setDigioKycCredentials, verifyDigioImageVerification,
  verifyDigioKyc, setDigioImageVerificationStatus, setDigioKycVerificationStatus, saveUserDeclaration,
  setUserDeclarationStatus, saveUserSign, setUserSignStatus,
  getAadhaarEsignCredentials, setAadhaarEsignCredentials, verifyAadhaarEsign, setAadhaarEsignVerificationStatus,
} = digioSlice.actions;

// Slice Reducer
export default digioSlice.reducer;
